import { createStore }  from 'vuex'

const state = {
    logo: '/img/logo/logo.md.png',
    status: {
        loading : false,
        response: {
            type:        '',
            icon:        '',
            title:       '',
            description: '',
            action:      null,
        },
    },
    mfa: 0,
}

const mutations = {
    REQUEST (state, {loading = true}) { 
        state.status = {
            loading  : loading === true,
            response : {type: '', icon: '', title: '', description: '', action: null}
        }
    },
    RESPONSE(state, {status, message, icon, action, reload = false}) {
        state.status.loading = false
        if (status == 'success') { state.status.response.type = 'success'  }
        if (status == 'error')   { state.status.response.type = 'danger'   }
        if (status == 'warning') { state.status.response.type = 'warning'  }
        if (status == null)      { state.status.response.type = 'info'     }
        if (message) {
            if (typeof message == 'string') { state.status.response.title       = message             } 
            if (message.title)              { state.status.response.title       = message.title       }
            if (message.description)        { state.status.response.description = message.description }
        }
        if (icon)   { state.status.response.icon   = icon   }
        if (action) { state.status.response.action = action }
        if (reload === true) { state.status.response.action = { label: 'Reload page', action: 'reload' } }
    },
    SET_MFA (state, payload) { 
        state.mfa = payload 
    },
}

const actions = {
    signup({ commit }, params) {
        commit('REQUEST', {})
        return axios.post('/register', params)
            .then(response => {
                commit('REQUEST', {loading: false})
                return true
            })
            .catch(error => {
                let message = parseError(error)
                commit('RESPONSE', {status: 'error', message: message})
                return null
            })
    },
    signin({ commit }, params) {
        commit('REQUEST', {})
        let route = (state.mfa !== 0) ? '/login-mfa' : '/login';
        return axios.post(route, params)
            .then(response => {
                if (response.status == 202) {
                    commit('REQUEST', {loading: false})
                    commit('SET_MFA', response.data.mfa)
                    return null
                }
                return response.data
            })
            .catch(error => {
                let message = parseError(error)
                commit('RESPONSE', {status: 'error', message: message})
                commit('SET_MFA', 0)
                return null
            })
    },
    forgot({ commit }, params) {
        commit('REQUEST', {})
        axios.post('/password/email ', {email: params.email})
            .then(response => {
                commit('RESPONSE', {status: 'success', message: response.data.message})
            })
            .catch(error => {
                let message = parseError(error)
                commit('RESPONSE', {status: 'error', message: message})
            })
    },
    reset({ commit }, params) {
        commit('REQUEST', {})
        axios.post('/password/reset', params)
            .then(response => {
                document.location = response.data
            })
            .catch(error => {
                let message = parseError(error)
                commit('RESPONSE', {status: 'error', message: message})
            })
    },
    activate({ commit }, params) {
        commit('REQUEST', {})
        axios.post('/activate', params).then(response => {
                document.location = response.data
            })
            .catch(error => {
                let message = parseError(error)
                commit('RESPONSE', {status: 'error', message: message})
            })
    }
}

export default createStore({
    state,
    mutations,
    actions
})
